'use strict';

var _ = require('lodash');

var configHandler = require('./configHandler');
var defaultDataHandler = require('./dataHandlers/defaultDataHandler');
var ispmDataHandler = require('./dataHandlers/ispmDataHandler');

var dataHandler = void 0;

dataHandler = {};

dataHandler.internalHandlerImpl = defaultDataHandler;

dataHandler.initLogiVersion = function (root, data, config) {
  console.log('init Logi dataHandler');
  dataHandler.framework = 'logi';
  dataHandler.setConfig(root, data, config, config.GUID, false);
};

dataHandler.initStandAloneVersion = function (root, data, config) {
  console.log('init StandAlone dataHandler ', config);
  dataHandler.framework = 'es6';
  dataHandler.setConfig(root, data, config, config.GUID, false);
};

dataHandler.initISPMVersion = function (root, data, config) {
  console.log('init ISPM dataHandler :', config);
  dataHandler.framework = 'ISPM';
  dataHandler.internalHandlerImpl = ispmDataHandler;

  dataHandler.setConfig(root, data, config, config.GUID, false);
};

dataHandler.initResearchProtoVersion = function (root, data, config, reportID, GUID) {

  console.log('init React proto dataHandler :', config);

  dataHandler.framework = 'react';
  dataHandler.currentReport = reportID;

  var generated = false;
  if (!config) {
    generated = true;
    config = configHandler.getGeneratedConfig(data[0], GUID);
  }

  dataHandler.setConfig(root, data, config, GUID, generated);
};

dataHandler.setConfig = function (root, data, config, GUID, generated) {
  var stateData = configHandler.setConfig(data, config, GUID, generated);

  //Temp until Logi or ISPM text API dB
  if (dataHandler.framework !== 'ISPM') {
    config.localTextAPI.validationWarnings.sampleSizeTooSmall += ' (n < ' + config.minSampleSize + ')';
    stateData.config.localTextAPI = config.localTextAPI;
  };

  dataHandler.setPatientsData(root, data, stateData, config.activePatient, GUID);
};

dataHandler.getChildElement = function (parentElement, id) {

  var children = parentElement.childNodes;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = children.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      if (child.id === id) {
        return child;
      }

      var innerChild = dataHandler.getChildElement(child, id);
      if (innerChild) return innerChild;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

dataHandler.setPatientsData = function (root, data, stateData, activePatient, GUID) {

  var patients = [];
  var activePatientFound = false;

  _.each(data, function (row, i) {

    // set and check GUID
    row['patientID'] = dataHandler.internalHandlerImpl.getPatientID(row, i, GUID);

    var patient = stateData.patientsIdMap[row['patientID']];
    // var patient = _.find(patients, function(p) { 
    //   if(p.features[['patientID']] === row['patientID']) return p;
    //   else return false;
    // });

    if (!patient) {
      patient = {};
      patient['features'] = {};
      patient['features']['patientID'] = row['patientID'];
      patient['features']['cohortIndex'] = row['cohortIndex'];

      //add generic cohort selector
      patient['features']['cohortValue'] = null;
      if (stateData.config.cohortSelector) {
        patient['features']['cohortValue'] = row[stateData.config.cohortSelector.column.id];

        var cohorts = stateData['config'].cohortSelector.cohorts;
        patient['features']['cohortIndex'] = dataHandler.getCohortIndex(patient['features']['cohortValue'], cohorts);
      };

      patient['paralelPlot'] = { path: [] };

      patients.push(patient);

      var fullName = dataHandler.internalHandlerImpl.getPatientName(row, i);
      patient['features'].name = {};
      patient['features'].name['fullName'] = fullName;

      // in case of wishing to override the patient's label that is used in the tooltip, override the getPatientTooltipLabel()
      //  method. If not, the patient's ID is used
      if (dataHandler.internalHandlerImpl.getPatientTooltipLabel) {
        patient['features'].name['tooltipLabel'] = dataHandler.internalHandlerImpl.getPatientTooltipLabel(row, i, fullName);
      }

      stateData.patientsIdMap[row['patientID']] = patient;
      if (!stateData.totalNRPatients) stateData.totalNRPatients = 0;
      stateData.totalNRPatients++;

      //add active patient
      if (activePatient && !activePatientFound) {

        // if the internal data-handler implementation needs to extract from the given row the active patient's ID:
        var activePatientId = activePatient.id;
        if (dataHandler.internalHandlerImpl.getActivePatientID) {
          activePatientId = dataHandler.internalHandlerImpl.getActivePatientID(row, activePatient);
        }

        if (patient.features.patientID === activePatientId) {
          stateData.activePatient = patient;
          activePatientFound = true;
        }
      }

      _.each(stateData['config']['dynamicColumns'], function (newColumn) {
        if (newColumn.operator.type === 'continuousToCategorical') {
          row[newColumn.target.id] = dataHandler.addContinuousToCategoricalRow(row[newColumn.source.id], newColumn);
        } else if (newColumn.operator.type === 'categoryToCategory') {
          row[newColumn.target.id] = dataHandler.addCategoricalToCategoricalRow(row[newColumn.source.id], newColumn);
        } else if (newColumn.operator.type === 'duplicate') {
          row[newColumn.target.id] = dataHandler.addDuplicatedColumn(row[newColumn.source.id], newColumn);
        } else if (newColumn.operator.type === 'clone') {
          row[newColumn.target.id] = _.clone(row[newColumn.source.id]);
        } else if (newColumn.operator.type === 'continuousToConfusion') {
          row[newColumn.target.id] = dataHandler.addConfusionMatrixColumn(row[newColumn.source.id], row[newColumn.operator.validator], newColumn.operator.threshold);
        } else if (newColumn.operator.type === 'merge') {

          //dataHandler.addMergedColumn

          row[newColumn.target.id] = '0';
          _.each(newColumn.operator.sources, function (entry) {
            _.each(newColumn.operator.acceptors, function (o) {
              if (o == row[entry]) row[newColumn.target.id] = o;
            });
          });
        }
      });

      dataHandler.setParalelPlotData(patient, stateData, row, activePatient);
    }
  });

  stateData['patients'] = patients;
  dataHandler.updateInitState(root, stateData, 'init');
};

dataHandler.getCohortIndex = function (value, cohorts) {

  // default is trash bin -1
  var cohortIndex = -1;
  var cat = void 0;
  _.each(cohorts, function (d, index) {
    cat = _.find(d.categories, function (c) {
      return c === value;
    });
    if (cat) cohortIndex = index;
  });

  return cohortIndex;
};

dataHandler.addMergedColumn = function (newColumn) {
  console.log('new merge column :', newColumn);
};

dataHandler.setParalelPlotData = function (patient, stateData, features, activePatient) {

  _.each(stateData['parallelPlot'], function (o) {

    var value = dataHandler.checkValue(features[o.column.id], o.scale.scaling);

    var p = { 'patientID': patient.features.patientID, value: value, cohortValue: patient.features.cohortValue };

    if (o.scale.scaling === 'continuous') {

      //set default units
      if (!o.scale.units) {
        o.scale.units = {
          metric: null,
          type: 'float',
          digits: 2
        };
      };
      if (o.scale.units.type.toLowerCase() === 'int' || o.scale.units.type.toLowerCase() === 'integer') o.scale.units.digits = 0;

      if (!o.column.patients) {
        o.column.patients = [];
        o.column.nrPatients = 0;
      }
      o.column.patients.push(p);

      dataHandler.addToPatientsId(o.column, p);

      if (o['filters'] && !activePatient) delete o['filters'];

      if (o['filters'] && activePatient.id === patient.features.patientID) {
        var min = value + o['filters']['similarPatient'][0];
        var max = value + o['filters']['similarPatient'][1];
        o['filters']['brush'] = [min, max];
      }
    } else {
      if (!o.column.nrCategories) o.column.nrCategories = 0;

      if (!o.column.categories) o.column.categories = {};

      if (!o.column['categories'][value]) {
        o.column['categories'][value] = { category: value, patients: [], label: value, nrPatients: 0 };

        if (o.labelPrefix && value !== 'NA') o.column['categories'][value].label = o.labelPrefix + value;

        if (o.mapCategoryLabel) {
          if (o.mapCategoryLabel[value]) o.column['categories'][value].label = o.mapCategoryLabel[value];
        }

        o.column.nrCategories++;
      };

      if (o['filters'] && !activePatient) delete o['filters'];

      if (o['filters']) {
        if (o['filters']['similarPatient'] && activePatient.id === patient.features.patientID) {
          o['filters']['categories'] = [value];
        } else if (o['filters']['userDefined']) {
          console.log('add user defined filter');
        }
      }

      var cat = o.column['categories'][value];
      cat.patients.push(p);
      dataHandler.addToPatientsId(cat, p);
    }

    patient.features[o.column.id] = value;
  });
};

dataHandler.addToPatientsId = function (container, patient) {

  if (!container.patientsIdMap) {
    container.patientsIdMap = {};
  }
  container.patientsIdMap[patient.patientID] = patient;
  container.nrPatients++; // count number of patients
};

dataHandler.addConfusionMatrixColumn = function (value, validation, threshold) {

  value = dataHandler.checkValue(value);
  validation = dataHandler.checkValue(validation);

  var cmfValue = 'NA';

  if (value >= threshold) {
    if (validation === 'Yes') {
      cmfValue = 'TP';
    } else {
      cmfValue = 'FP';
    }
  } else if (value < threshold) {
    if (validation === 'No') {
      cmfValue = 'TN';
    } else {
      cmfValue = 'FN';
    }
  }

  return cmfValue;
};

dataHandler.addDuplicatedColumn = function (value, newColumn) {
  value = dataHandler.checkValue(value);
  return value;
};

dataHandler.addCategoricalToCategoricalRow = function (value, newColumn) {

  var newCategory = void 0;
  _.each(newColumn.operator.deviders, function (d) {
    var inBucket = value.search(d.category);
    if (inBucket >= 0) newCategory = d.category;
  });

  return newCategory;
};

dataHandler.addContinuousToCategoricalRow = function (value, newColumn) {

  value = dataHandler.checkValue(value);
  if (isNaN(value)) return value;

  var newValue = void 0;

  if (newColumn.operator.devider === 'range') {
    _.each(newColumn.operator.deviders, function (d) {
      var inBucket = evaluateRange(value, d.start, d.end);
      if (inBucket) newValue = d.category;
    });
  } else if (newColumn.operator.devider === 'every') {
    newValue = Math.floor(value / newColumn.operator.range) * newColumn.operator.range;
    newValue = newValue + '-' + (newValue + newColumn.operator.range);
  }

  return newValue;

  function evaluateRange(value, start, end, equal) {

    var operator = start.operator + ' ' + end.operator;

    switch (operator) {
      case "==":
        return value === equal.value;
      //break;
      case "> <":
        return value > start.value && value < end.value;
      //break;
      case ">= <":
        return value >= start.value && value < end.value;
      //break;
      case "> <=":
        return value > start.value && value <= end.value;
      //break;
      case ">= <=":
        return value >= start.value && value <= end.value;
      //break;
      default:
        return value;

    }
  }
};

dataHandler.checkValue = function (value, scaling) {

  if (value === "" || value === undefined || value === null) return 'NA';

  var v = Number(value);

  if (!isNaN(v)) {
    return v;
  } else if (scaling === 'continuous') {
    // value is NaN and it is a numeric column
    return 'NA';
  }

  if (!value.toLowerCase) {
    // if toLowerCase() is not supported - return value as it is
    return value;
  }
  v = value.toLowerCase();

  if (!v || v === 'na' || v === 'n/a') return 'NA';
  if (v === 'true' || v === 'yes') return 'Yes';
  if (v === 'false' || v === 'no') return 'No';
  if (v === 'missing') return 'Missing';
  if (v === 'blank') return 'Blank';
  if (v === 'is') return -1;

  return value;
};

dataHandler.updateInitState = function (root, stateData, updateType) {

  console.log(stateData);

  var realTimeUpdate = true;
  if (stateData.patients.length >= 750) realTimeUpdate = false;

  if (dataHandler.framework === 'react') {
    root.setState({
      data: stateData,
      graphUpdate: true,
      updateType: updateType,
      realTimeUpdate: realTimeUpdate,
      environment: dataHandler.framework
    });
  } else {
    root.stateProps.data = stateData;
    root.stateProps.updateType = updateType;
    root.stateProps.realTimeUpdate = realTimeUpdate;

    root.setState(root.stateProps);
  }
};

module.exports = dataHandler;